export const getDeviceMedia = (size) => {
    if(size < 768) {
        return 'mobile';
    } return 'web'
}
export const getTileDeviceMedia = (size) => {
    if(size < 360) {
        return 'mobileSxx';
    }
    if(size < 400) {
        return 'mobileSx';
    } else if(size < 480) {
        return 'mobileSm'
    } else if(size < 600) {
        return 'mobileXs'
    } else if(size < 768) {
        return 'mobileXxs'
    } return 'web'
}

export const getESDeviceMedia = (size) => {
    if(size < 414) {
        return 'mobileSx';
    } else if(size < 768) {
        return 'mobile';
    } return 'web'
}